export default {
  lightGreen: "#6dc05e",
  lightBlue: "#50A1FF",
  lightGrey: "#6C7B8A",

  backgroundBlue: "#F1F5FB"
};
